module.exports = __webpack_public_path__ + "static/media/simplewine.6caa1660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleWine/simplewine.jpg
// module id = 421
// module chunks = 0